import React, { Component } from "react";
import SignaturePad from "react-signature-canvas";
import { withTranslation } from "react-i18next";
import { NormalButton } from "../NormalButton";
import "./style.scss";
export class SignPanelClass extends Component {
  state = { trimmedDataURL: null };
  sigPad = {};
  clear = () => {
    this.sigPad.clear();
    this.props.handleToClearSigPad();
  };
  trim = () => {
    this.setState({
      trimmedDataURL: this.sigPad.getTrimmedCanvas().toDataURL("image/png"),
    });
    setTimeout(() => {
      this.props.handleSignSaveClick(this.state.trimmedDataURL);
    }, 500);
  };

  render() {
    return (
      <>
        <SignaturePad
          canvasProps={{ className: `border sigPad mt-3` }}
          ref={(ref) => {
            this.sigPad = ref;
          }}
        />
        <p>Customer Signature</p>

        <div className="row mt-2">
          <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <NormalButton
              className={`pt-2`}
              onClick={this.clear}
              label="Clear"
              resetbg={true}
            />
          </div>
          <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <NormalButton
              className={`pt-2`}
              submitBtn={true}
              onClick={this.trim}
              label="Save"
            />
          </div>
        </div>
      </>
    );
  }
}

export const SignPanel = withTranslation()(SignPanelClass);
